import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import React, { useState } from 'react'
import useGenericEndpoint from '../hooks/api/useGenericEndpoint'

import useIsAdmin from '../hooks/useIsAdmin'
import { green, orange, red, yellow } from '@mui/material/colors'

const resultCodes = {
  A: { color: green[700], text: 'Approved' },
  P: { color: yellow[700], text: 'Partial Approval' },
  D: { color: red[700], text: 'Declined' },
  E: { color: red[700], text: 'Error' },
  V: { color: orange[700], text: 'Verification Required' },
}

const BillingHistory = ({ nextDateDisplay, billingQuery }) => {
  const { isAdmin } = useIsAdmin()

  const isEnabled = billingQuery.data?.schedule.enabled !== '0'

  const { data, isLoading, hasLoadError } = useGenericEndpoint(
    '/api/billing/history',
    {
      shouldPreventCall: !isAdmin,
    }
  )

  return (
    <Card>
      <CardContent>
        <Typography variant='h5' sx={{ mb: 2 }}>
          Transaction History
        </Typography>
        {isEnabled && (
          <Typography sx={{ mb: 2 }}>
            Next payment on <b>{nextDateDisplay}</b>
          </Typography>
        )}
        <Box>
          {isLoading && <CircularProgress />}
          {!isLoading && (
            <>
              {data.length === 0 && (
                <Typography>
                  <i>You have not yet been billed</i>
                </Typography>
              )}

              {data.length > 0 && (
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Date</TableCell>
                        <TableCell>Payment Type</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Billing Cycle</TableCell>
                        <TableCell>Payment Total</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.map((d) => {
                        const { text, color } = resultCodes[d.result_code]
                        return (
                          <TableRow>
                            <TableCell>{d.created}</TableCell>
                            <TableCell>{d.trantype}</TableCell>
                            <TableCell sx={{ color }}>
                              <b>{text}</b>
                            </TableCell>
                            <TableCell>Monthly</TableCell>
                            <TableCell>{d.amount}</TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </>
          )}
        </Box>
      </CardContent>
    </Card>
  )
}

export default BillingHistory
